module.exports = __webpack_public_path__ + "static/media/mobile-blog.35bd1d02.png";